import { ETextStyleVariant, Text } from '@outdoorsyco/bonfire';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import ClampModal from '@/components/route/listing/ClampModal/ClampModal';
import FeatureItem from '@/components/route/listing/Features/FeatureItem';
import { ModalContent } from '@/components/route/listing/LocationHighlights/LocationHighlights';
import { ELocationDetails, LOCATION_DETAILS_ICONS } from '@/constants/locationDetails';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import { getCampgroundLocationDetails } from '@/redux/selectors/campgrounds/page';

export const ClaimedCampgroundHighlights = () => {
  const locationDetails = useSelector(getCampgroundLocationDetails);
  const intl = useIntl();
  const { isMobile } = useBreakpoint();

  if (!locationDetails) {
    return null;
  }
  const { sceneries: sceneryDetails, activities: activitiesDetails } = locationDetails;

  if (!sceneryDetails.length || !activitiesDetails.length) {
    return null;
  }
  const totalLength = sceneryDetails.length + activitiesDetails.length;
  const length =
    sceneryDetails.length >= activitiesDetails.length
      ? activitiesDetails.length
      : sceneryDetails.length;
  const showMoreText = intl.formatMessage(
    {
      defaultMessage: 'Show all {highlightCount, plural, one {# highlight} other {# highlights}}',
      id: 'i7Lhwa',
    },
    { highlightCount: totalLength },
  );
  const title = intl.formatMessage({
    defaultMessage: 'Highlights',
    id: 'KGmQjH',
  });

  return (
    <div>
      <Text variant={ETextStyleVariant.LargeBold} className="mb-6">
        {title}
      </Text>
      <ClampModal
        showMoreText={showMoreText}
        lineCount={4}
        isList
        hasMore={totalLength > (isMobile ? 4 : 6)}
        modalContent={
          <ModalContent sceneryDetails={sceneryDetails} activitiesDetails={activitiesDetails} />
        }
        modalTitle={title}>
        <div className="grid gap-0 grid-cols-2">
          <div className={'mt-0'}>
            <ul data-testid="location-details-list">
              {sceneryDetails.slice(0, isMobile ? 2 : length > 2 ? 3 : 2).map(item => (
                <li
                  key={item.type}
                  className="mb-4 text-base font-normal text-primary-base semiHighlight"
                  data-testid={`listing-location-details-${item.type}`}>
                  <FeatureItem
                    BonfireIcon={LOCATION_DETAILS_ICONS[item.type as ELocationDetails]}
                    label={item.label}
                  />
                </li>
              ))}
            </ul>
          </div>
          <div className="mt-0">
            <ul data-testid="location-details-list">
              {activitiesDetails.slice(0, isMobile ? 2 : length > 2 ? 3 : 2).map(item => (
                <li
                  key={item.type}
                  className="mb-4 text-base font-normal text-primary-base semiHighlight"
                  data-testid={`listing-location-details-${item.type}`}>
                  <FeatureItem
                    BonfireIcon={LOCATION_DETAILS_ICONS[item.type as ELocationDetails]}
                    label={item.label}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </ClampModal>
    </div>
  );
};
